import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, watch } from 'vue'
import Vue from 'vue'

import getTableColumns from './data'

// 需要做特殊映射的值

export default /*#__PURE__*/_defineComponent({
  __name: 'record-table',
  props: {
    tData: null,
    tableType: null
  },
  setup(__props: any) {

const props = __props as {
  tData: any[]
  tableType: string
}

const specialMap = new Map([
  ['V', '纵切锯片'],
  ['H', '横切锯片'],
  ['0000', '向0点坐标切割'],
  ['9999', '远离0点坐标切割'],
])

const directionMap = new Map([
  ['front', '前边'],
  ['back', '后边'],
  ['left', '左边'],
  ['right', '右边'],
  ['top', '上边'],
  ['bottom', '下边'],
])



const columns = ref<any[]>([])
const columnsMap = ref<Map<string, string>>(
  new Map([
    ['matCode', '板材材质'],
    ['color', '板材颜色'],
    ['thick', '板材厚度(mm)'],
    ['width', '板材宽度(mm)'],
    ['height', '板材长度(mm)'],
    ['isPicked', '默认启用'],
    ['depth', '深度范围'],
    ['highlight', '高光属性'],
    ['pThick', '板件厚度(mm)'],
    ['firstCut', '第一次'],
    ['secondCut', '第二次'],
    ['thirdCut', '第三次'],
    ['number', '排钻编号'],
    ['number2', '工位2排钻编号'],
    ['diameter', '钻头直径'],
    ['isUsed', '启用'],
    ['xOffset', 'X偏移'],
    ['yOffset', 'Y偏移'],
    ['zOffset', '升降坐标偏移'],
    ['imageNamePrefix', '排版图名前缀'],
    ['imageFormat', ' 排版图格式'],
    ['imageDirection', '排版图方向'],
    ['imageSize', '排版图尺寸'],
    ['desc', '编号'],
    ['id', '编号'],
    ['_selected', '基准钻'],
    ['cutable', '开料'],
    ['holeable', '打孔'],
    ['millableHole', '铣孔'],
    ['millableSlot', '铣槽'],
    ['slotable', '拉槽'],
    ['name', '孔槽'],
    ['importHeader', '表头'],
    ['headerString', '内容'],
    ['startCode', '换刀开始代码'],
    ['startCode2', '工位2换刀开始代码'],
    ['stopCode2', '工位2换刀结束代码'],
    ['endCode', '换刀结束代码'],
    ['stopCode', '换刀结束代码'],
    ['preStartCode', '预启动代码'],
    ['type', '类型'],
    ['offsetX', '偏移X'],
    ['offsetY', '偏移Y'],
    ['axis_offset', '轴偏移'],
    ['arc_radius', '圆弧半径'],
    ['offsetZ', '偏移Z'],
    ['offsetNo', '偏移号'],
    ['cutVelocity', '下刀[F]mm/min'],
    ['drillVelocity', '加工[F]mm/min'],
    ['rotationlSpeed', '转速[S]r/min'],
    ['enable', '启用'],
    ['moveF', ' XY轴快速移动速度'],
    ['axis_offset', '轴偏移'],
    ['arc_radius', '圆弧半径'],
    ['moveZF', 'Z轴快速移动速度'],
    ['feedRate', 'Z轴加工速度'],
    ['cutF', 'XY加工速度'],
    ['cutZF', 'Z轴加工速度'],
    ['use', '用途'],
    ['saw_width', '刀宽度'],
    ['saw_direction', '锯片类型'],
    ['cut_from', '切割方向'],
    ['move_speed', '空走速度'],
    ['cut_speed', '加工速度'],
    ['start_code', '换刀开始代码'],
    ['end_code', '换刀结束代码'],
    ['saw_down_code', '下刀代码'],
    ['saw_up_code', '收刀代码'],
    ['abscissa', '横坐标前缀'],
    ['ordinate', '纵坐标前缀'],
    ['cutable', '开料'],
    ['serial_num', '编号'],
    ['knifePrefix', '排钻编号前缀'],
    ['knifeSuffix', '排钻编号后缀'],
    ['knifePurpose', '刀用途'],
    ['x_offset', '横向坐标偏移'],
    ['y_offset', '纵向坐标偏移'],
    ['z_offset', '升降坐标偏移'],
    ['moveSpeed', '快速进给速度'],
    ['doSpeed', '加工速度'],
    ['knifeName', '编号'],
    ['specialHoleSlot', '特殊孔槽'],
    ['side', '所在大板面'],
    ['diameter', '直径'],
    ['long_side', '槽长'],
    ['short_side', '槽短'],
    ['length', '刀具长度'],
    ['maximum_single_depth', '单次最大加工深度'],
    ['idx', '序号'],
    ['five_six_use', '用途'],
    ['knife_name', '刀具编号'],
    ['type', '类型'],
    ['min_length', '长度1'],
    ['max_length', '长度2'],
    ['marking', '标识为'],
    ['min_thick', '厚度1'],
    ['max_thick', '厚度2'],
    ['thick_mark', '标识为'],
    ['hole_operator', '条件'],
    ['hole_value', '孔直径(mm)'],
    ['slot_length_operator', '槽长边条件'],
    ['slot_length_value', '槽长边(mm)'],
    ['slot_width_operator', '槽短边条件'],
    ['slot_width_value', '槽短边(mm)'],
    ['knife', '下料刀具'],
    ['is_highlight', '高光板'],
    ['surplus_name', '余料名称'],
    ['long', '长度(mm)'],
    ['min_long', '短边长度(mm)'],
    ['min_width', '短边宽度(mm)'],
    ['area', '面积(m²)'],
    ['surplus_trim_edge', '修边'],
    ['is_high_gloss_plank', '高光板'],
    ['branch_name', '所在余料库'],
    ['amount', '数量'],
    ['shape', '板材形状'],
    ['remark', '备注'],
    ['branch_no', '编号'],
    ['store_name', '余料库名称'],
    ['quantity', '已存余料数量(个)'],
    ['capacity', '余料库存上限(个)'],
    ['surplus_rules', '余料入库规则'],
    ['address', '订单'],
    ['customer_name', '客户'],
    ['plankID', '板号'],
    ['texture', '颜色'],
    ['sizeStr', '尺寸(长*宽*厚)'],
    ['plankNum', '板件条码'],
    ['create_time', '保存时间'],
    ['brand_name', '品牌'],
    ['supplier_name', '供应商'],
    ['trim_edge', '修边尺寸'],
    ['edge_distance', '距板件边缘(mm)'],
    ['edge_part_length', '靠边部分长度(mm)'],
    ['slot_depth', '槽深度(mm)'],
    ['first_cut_deep', '首次切割深度(mm)'],
    ['plankLength', '板件长度(L)'],
    ['count', '连接桥数'],
    ['plank_name', '板件名'],
    ['plank_edge', '板件边'],
    ['device_side', '固定在设备'],
  ])
)

const imgDrection = ref<Map<string, string>>(
  new Map([
    ['horiz', '横向'],
    ['vert', '竖向'],
  ])
)

// 刀具类型映射
const typeMap = ref<Map<string, string>>(
  new Map([
    ['mill', '铣刀'],
    ['dill', '钻头'],
    ['stylingKnife', '造型刀'],
    ['obliqueDrill', '斜钻'],
    ['laser', '激光刀'],
  ])
)

const isIrregularMillingPermission = ref(false)

function handleIrregularMillingPermission() {
  Vue.prototype.$getByToken(
    '/user_permission',
    { permission_type: 'ZK_IN_AIO' },
    (res: any) => {
      if (res.status == 1) {
        isIrregularMillingPermission.value = res.data.enable
      }
    }
  )
}

onMounted(() => {
  handleIrregularMillingPermission()
})

function handleTypeMap(row: any) {
  const arr = ['mill', 'dill', 'laser']
  if (arr.includes(row.type)) {
    return typeMap.value.get(row.type)
  } else {
    const match = row?.type?.match(/^(\D+)(\d*)$/)
    if (match) {
      // 造型刀1、造型刀2、、、
      const prefix = match[1] // 前缀部分（非数字）
      const suffix = match[2] // 后缀（数字部分）
      return typeMap.value.get(prefix) + suffix
    }
  }
}

function tableRowClassName({ row }: any) {
  let className = ''
  if (row.operate_type) {
    className =
      row.operate_type === 'add'
        ? 'add-record'
        : row.operate_type === 'edit'
        ? 'edit-record'
        : 'delete-record'
  }
  if (row.isOld) {
    className = 'old-record'
  }
  return className
}
function formatRange(min: number, max: number) {
  if (!isNaN(min)) {
    return `${min} - ${max}`
  } else {
    return ''
  }
}
function formatLabel(column: any) {
  if (
    (props.tableType === 'knife_store_table' ||
      props.tableType === 'side_hole_knife_store_table' ||
      props.tableType === 'ptp_knife_store_table' ||
      props.tableType === 'model_aio_table' ||
      props.tableType === 'five_six_knives_table' ||
      props.tableType === 'laser_cutting_machine_table') &&
    column.prop.includes('diameter')
  ) {
    return '刀直径ф'
  } else if (
    (props.tableType === 'knife_store_table' ||
      props.tableType === 'model_aio_table' ||
      props.tableType === 'laser_cutting_machine_table') &&
    column.prop.includes('name')
  ) {
    if (props.tableType === 'knife_store_table') {
      return '名称'
    } else {
      return '编号'
    }
  } else if (
    (props.tableType === 'side_hole_knife_store_table' ||
      props.tableType === 'model_aio_table') &&
    column.prop.includes('xOffset')
  ) {
    if (props.tableType === 'side_hole_knife_store_table') {
      return '横坐标偏移'
    } else {
      return 'X坐标偏移'
    }
  } else if (
    (props.tableType === 'side_hole_knife_store_table' ||
      props.tableType === 'model_aio_table') &&
    column.prop.includes('yOffset')
  ) {
    if (props.tableType === 'side_hole_knife_store_table') {
      return '纵坐标偏移'
    } else {
      return 'Y坐标偏移'
    }
  } else if (
    props.tableType === 'model_aio_table' &&
    column.prop.includes('zOffset')
  ) {
    return 'Z坐标偏移'
  } else if (
    props.tableType ===
      'side_hole_drill_setting_drill_combination_from_hole_table' &&
    column.prop.includes('name')
  ) {
    return '从孔名称'
  } else if (
    props.tableType === 'side_hole_old_knife_store_table_v3' &&
    column.prop.includes('diameter')
  ) {
    return '刀宽'
  } else {
    return column.label
  }
}
function sortKeys(tableType: any) {
  return getTableColumns(tableType)
}

watch(
  () => props.tData,
  (val) => {
    let arr = []
    val.forEach((element) => {
      arr.push(...Object.keys(element))
    })
    let keys = sortKeys(props.tableType)
    const filterArr = [
      'window_plank_id',
      'operate_type',
      'item_type',
      'maxDepth',
      'maxDiameter',
      'maxWidth',
      'index',
      'webId',
      'origin',
      'isSelected',
      'head',
      'word',
      'headerIds',
    ]
    if (keys) {
      columns.value = keys
        .filter((e: any) => !filterArr.includes(e))
        .map((key: any) => {
          if (key.includes('Diameter')) {
            return {
              prop: key,
              label: '孔直径范围',
            }
          } else if (key.includes('Depth')) {
            return {
              prop: key,
              label: columnsMap.value.get('depth'),
            }
          } else if (key.includes('Width')) {
            return {
              prop: key,
              label: '槽宽度范围',
            }
          } else {
            return {
              prop: key,
              label: columnsMap.value.get(key),
            }
          }
        })
    }
  },
  {
    immediate: true,
    deep: true,
  }
)

return { __sfc: true,specialMap, directionMap, props, columns, columnsMap, imgDrection, typeMap, isIrregularMillingPermission, handleIrregularMillingPermission, handleTypeMap, tableRowClassName, formatRange, formatLabel, sortKeys }
}

})